// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { isCanada } from '@tcp/core/src/utils/utils';
import Button from '@tcp/core/src/components/common/atoms/Button';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import ClickTracker from '@tcp/web/src/components/common/atoms/ClickTracker';
import { routerPush } from '@tcp/core/src/utils';
import { convertHtml } from '@tcp/core/src/components/features/CnC/LoyaltyBanner/util/utility';
import { getContinueAsGuestPayload } from '@tcp/core/src/constants/analytics';
import { setContactFormValuesInSS } from '@tcp/core/src/components/features/CnC/SinglePageCheckout/molecules/ContactForm/ContactForm.util';
import styles from './styles/LoginHelloScreen.styles';
import { getLabelFromCopyOrFromTranslation } from '../../../../../../../utils/labels/labelUtilty';
import {
  GLOBAL_LOGIN_LABELS,
  GlobalLoginLabels,
  lblLobinCheckoutHelloLabel,
  lblLoginBackToBag,
  lblLoginCheckoutAsGuest,
  lblLoginCheckoutHelloScreenPoints,
  lblLoginCheckoutHelloScreenRewards,
  lblLoginCreateAccount,
  lblLoginCreateAccountBannerTitle2,
  lblLoginCreateAccountBannerTitle3,
  lblLoginCreateAccountFasterCheckoutCa,
  lblLoginCreateAcntBtn,
  lblLoginDifferentEmail,
  lblLoginOr,
  lblEveryPurchase,
} from '../../../../../../../utils/labels/globalLogin.labels';
import {
  GLOBAL_ACTIONS_LABELS,
  GlobalActionsLabels,
  lblCreateAccount,
} from '../../../../../../../utils/labels/globalActions.labels';
import {
  GLOBAL_ACCESSIBILITY_LABELS,
  GlobalAccessibilityLabels,
  myPlaceRewards,
} from '../../../../../../../utils/labels/globalAccessibility.labels';
import {
  GLOBAL_REGISTRATION_LABELS,
  GlobalRegistrationLabels,
  lblcreateAcntPointRwd,
} from '../../../../../../../utils/labels/globalRegistrations.labels';

class LoginHelloScreen extends React.PureComponent {
  constructor(props) {
    super(props);
    this.loginLabels = getLabelFromCopyOrFromTranslation(GLOBAL_LOGIN_LABELS, GlobalLoginLabels);
  }

  /* istanbul ignore next */
  onClickDifferentEmail = (e) => {
    e.preventDefault();
    const { saveExistingUserResponse, trackAnalyticsClick } = this.props;
    saveExistingUserResponse('');
    setContactFormValuesInSS();
    trackAnalyticsClick({
      metric33: '1',
      eVar150: this.loginLabels[lblLoginDifferentEmail],
      customEvents: ['event33'],
    });
  };

  onCheckoutAsGuest = () => {
    const { handleContinueAsGuest } = this.props;
    handleContinueAsGuest();
  };

  /* istanbul ignore next */
  showCreateAccountForm = () => {
    const {
      onClose,
      openOverlay,
      closeModal,
      fullPage,
      closeOverlay,
      fullPageAuthEnabled,
      variation,
      trackAnalyticsClick,
    } = this.props;
    trackAnalyticsClick({
      metric33: '1',
      eVar150: this.loginLabels[lblLoginCreateAcntBtn],
      customEvents: ['event33'],
    });
    const { pathname = 'referrer' } = (window && window.location) || {};
    if (variation !== 'favorites' && (fullPage || fullPageAuthEnabled)) {
      closeOverlay();
      routerPush(
        `/home?target=register-checkout&successtarget=${pathname}`,
        '/home/register-checkout'
      );
    } else {
      openOverlay({
        component: 'createAccount',
        variation: 'primary',
      });
    }
    onClose();
    closeModal();
  };

  getRewardPoints = (totalRewards, totalPoints) => {
    const formatRewards = totalRewards && totalRewards.replace('Reward', '');
    const labelValue = totalRewards
      ? this.loginLabels[lblLoginCheckoutHelloScreenRewards]
      : this.loginLabels[lblLoginCheckoutHelloScreenPoints];
    const finalLabel = `<span>${labelValue?.replace(
      totalRewards ? '#rewards' : '#points',
      `<span class="reward-points-style">${totalRewards ? formatRewards : totalPoints}</span>`
    )}</span>`;
    return convertHtml(finalLabel);
  };

  render() {
    const {
      className,
      emailAddressFromSS,
      backToBag,
      isRememberedUser,
      variation,
      totalRewards,
      totalPoints,
      isV2Flow,
    } = this.props;
    const spc = variation === 'checkout';
    const headerLabel = getLabelFromCopyOrFromTranslation(
      `${GLOBAL_ACCESSIBILITY_LABELS}.${myPlaceRewards}`,
      GlobalAccessibilityLabels
    ).split(' ');
    return (
      <div className={className}>
        <BodyCopy
          fontSize="fs26"
          fontFamily="secondary"
          textAlign="center"
          className="elem-mt-XXXL"
          fontWeight="extrabold"
        >
          {this.loginLabels[lblLobinCheckoutHelloLabel]}
        </BodyCopy>
        {isCanada() ? (
          <BodyCopy textAlign="center" component="div">
            <BodyCopy fontSize="fs13" fontFamily="secondary" textAlign="center" fontWeight="bold">
              {this.loginLabels[lblLoginCreateAccountFasterCheckoutCa]}
            </BodyCopy>
          </BodyCopy>
        ) : (
          <BodyCopy textAlign="center" component="div">
            <BodyCopy textAlign="center" component="div">
              <BodyCopy
                fontSize="fs13"
                fontFamily="secondary"
                textAlign="center"
                fontWeight="bold"
                className=" login_earn_points"
              >
                {this.loginLabels[lblLoginCreateAccount]}
              </BodyCopy>
              <BodyCopy
                component="span"
                fontSize="fs13"
                fontFamily="secondary"
                textAlign="center"
                fontWeight="bold"
                className="create-account elem-pl-XXXS"
              >
                {this.loginLabels[lblEveryPurchase]}
                <BodyCopy component="span" className="my-place-rewards elem-ml-XXXS line-break">
                  <BodyCopy
                    component="span"
                    fontWeight="extrabold"
                    fontSize="fs13"
                    className="text-style-1 elem-ml-XXM"
                    fontFamily="secondary"
                  >
                    {headerLabel[0] ? `${headerLabel[0]} ` : ''}
                  </BodyCopy>
                  <BodyCopy
                    component="span"
                    fontWeight="extrabold"
                    fontSize="fs13"
                    className="text-style-2"
                    fontFamily="secondary"
                  >
                    {headerLabel[1] ? `${headerLabel[1]} ` : ''}
                  </BodyCopy>
                  <BodyCopy
                    component="span"
                    fontWeight="extrabold"
                    fontSize="fs13"
                    className="text-style-3"
                    fontFamily="secondary"
                  >
                    {headerLabel[2] ? `${headerLabel[2]} ` : ''}
                  </BodyCopy>
                  <BodyCopy
                    className="elem-mt-XXS login-reward-points"
                    fontSize="fs13"
                    fontFamily="secondary"
                    textAlign="center"
                    fontWeight="bold"
                  >
                    {getLabelFromCopyOrFromTranslation(
                      `${GLOBAL_REGISTRATION_LABELS}.${lblcreateAcntPointRwd}`,
                      GlobalRegistrationLabels
                    )}
                  </BodyCopy>
                </BodyCopy>
              </BodyCopy>
            </BodyCopy>
          </BodyCopy>
        )}
        <BodyCopy component="div" textAlign="center" className="underline" />

        {emailAddressFromSS && (
          <>
            <BodyCopy
              textAlign="center"
              fontWeight="extrabold"
              fontSize="fs13"
              fontFamily="secondary"
              className="elem-mt-XL_1"
            >
              {emailAddressFromSS}
            </BodyCopy>
            <BodyCopy component="div" textAlign="center">
              <Anchor
                noLink
                underline
                fontSizeVariation="large"
                fontSize="fs14"
                anchorVariation="primary"
                dataLocator="Use a Different Email"
                onClick={this.onClickDifferentEmail}
                className="different-email-link"
              >
                {this.loginLabels[lblLoginDifferentEmail]}
              </Anchor>
            </BodyCopy>
          </>
        )}

        <BodyCopy
          fontSize="fs19"
          fontFamily="secondary"
          textAlign="center"
          className="elem-mt-XL_1"
        >
          <div className="create-account-banner elem-mb-MED">
            <Button
              fill="BLUE"
              type="submit"
              buttonVariation="fixed-width"
              dataLocator="create-account-checkout"
              fullWidth
              onClick={this.showCreateAccountForm}
              className="elem-mb-XS login-button-test-class button-radious"
            >
              {isV2Flow
                ? this.loginLabels[lblLoginCreateAcntBtn]
                : getLabelFromCopyOrFromTranslation(
                    `${GLOBAL_ACTIONS_LABELS}.${lblCreateAccount}`,
                    GlobalActionsLabels
                  )}
            </Button>
            <ul className="elem-mt-XS_1 elem-mb-MED">
              {!isCanada() && (
                <BodyCopy component="li" fontSize="fs16" fontFamily="secondary">
                  {this.getRewardPoints(totalRewards, totalPoints)}
                </BodyCopy>
              )}
              <BodyCopy component="li" fontSize="fs16" fontFamily="secondary">
                {this.loginLabels[lblLoginCreateAccountBannerTitle2]}
              </BodyCopy>
              <BodyCopy component="li" fontSize="fs16" fontFamily="secondary">
                {this.loginLabels[lblLoginCreateAccountBannerTitle3]}
              </BodyCopy>
            </ul>
          </div>
          {isV2Flow && this.loginLabels[lblLoginOr]}
        </BodyCopy>

        {!isRememberedUser && isV2Flow && (
          <div className="elem-mb-LRG elem-mt-MED">
            <ClickTracker clickData={getContinueAsGuestPayload('checkout-popup')}>
              <Button
                fill="WHITE"
                type="button"
                buttonVariation="fixed-width"
                dataLocator="login-logincta"
                fullWidth
                onClick={this.onCheckoutAsGuest}
                spc={spc}
                className="button-radious"
              >
                {this.loginLabels[lblLoginCheckoutAsGuest]}
              </Button>
            </ClickTracker>
          </div>
        )}

        {isV2Flow && (
          <BodyCopy component="div" textAlign="center">
            <Anchor
              underline
              fontSizeVariation="large"
              fontSize="fs14"
              anchorVariation="primary"
              dataLocator="Back to Bag"
              onClick={backToBag}
              className="elem-mt-MED_2"
              textAlign="center"
            >
              {this.loginLabels[lblLoginBackToBag]}
            </Anchor>
          </BodyCopy>
        )}
      </div>
    );
  }
}

LoginHelloScreen.propTypes = {
  initialValues: PropTypes.shape({}).isRequired,
  queryParams: PropTypes.shape({}).isRequired,
  formErrorMessage: PropTypes.shape({}).isRequired,
  logoutlabels: PropTypes.shape({}),
  saveExistingUserResponse: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  fullPage: PropTypes.bool.isRequired,
  closeOverlay: PropTypes.func.isRequired,
  fullPageAuthEnabled: PropTypes.bool.isRequired,
  variation: PropTypes.string.isRequired,
  className: PropTypes.string,
  emailAddressFromSS: PropTypes.string.isRequired,
  backToBag: PropTypes.func.isRequired,
  isRememberedUser: PropTypes.bool.isRequired,
  handleContinueAsGuest: PropTypes.func.isRequired,
  isV2Flow: PropTypes.bool,
};

LoginHelloScreen.defaultProps = {
  className: '',
};

export default withStyles(LoginHelloScreen, styles);
export { LoginHelloScreen as LoginHelloScreenVanilla };
